<template>
  <div class="create-timeslot-form">
    <div class="add-time">
      <span class="time-dots">Где открыть запись</span>
      <select
        v-model="newSlot.source"
      >
        <option
          v-for="source in sources"
          :key="source.id"
          :value="source.id"
        >
          {{ source.name }}
        </option>
      </select>
    </div>
    <div class="add-time">
      <span class="time-dots">Начало приёма в этот день</span>
      <v-field
        v-model="newSlot.startTime.hour"
        ref="newStartTime_hour"
        size="sm"
        name="start_hour"
        max-length="2"
        placeholder="ЧЧ"
        type="number"
      />
      <span class="time-dots">:</span>
      <v-field
        v-model="newSlot.startTime.minutes"
        size="sm"
        max-length="2"
        ref="newStartTime_minutes"
        name="start_minutes"
        placeholder="ММ"
        type="number"
      />
    </div>
    <div class="add-time">
      <span class="time-dots">Окончание приёма в этот день</span>
      <v-field
        v-model="newSlot.endTime.hour"
        size="sm"
        name="end_hour"
        ref="newEndTime_hour"
        max-length="2"
        placeholder="ЧЧ"
        type="number"
      />
      <span class="time-dots">:</span>
      <v-field
        v-model="newSlot.endTime.minutes"
        size="sm"
        max-length="2"
        ref="newEndTime_minutes"
        name="end_minutes"
        placeholder="ММ"
        type="number"
      />
    </div>
    <div class="add-time">
      <span class="time-dots">Длительность слота</span>
      <!--
      TODO: change into code names?
      newSlot.source: 1 - ЕПГУ, 2 - mos.ru
      -->
      <v-field
        v-model="newSlot.interval"
        :readonly="newSlot.source == 1 || newSlot.source == 2"
        size="sm"
        name="interval"
        ref="interval"
        max-length="2"
        placeholder="ММ"
        type="number"
      />
      <span class="time-dots">мин.</span>
    </div>
    <div>
      <span class="time-dots">Количество возможных записей на один слот длительностью {{ newSlot.interval }} минут</span>
      <v-field
        v-model="newSlot.overlaps"
        size="sm"
        max-length="2"
        ref="overlaps"
        name="overlaps"
        placeholder="1"
        type="number"
      />
    </div>
    <div>
      <span class="time-dots">
        Количество возможных записей для всего интервала {{ currentTimeInterval }}
      </span>
      <v-field
        v-model="newSlot.capacity"
        size="sm"
        max-length="2"
        ref="capacity"
        name="capacity"
        placeholder="1"
        type="number"
      />
    </div>
    <div>
      <v-button
        text="добавить время"
        class="link"
        @click="submitNewSlot"
      />
    </div>
  </div>
</template>

<script>
import VField from "@/components/VField";
import VButton from "@/components/VButton";
import { validateHour, validateMinutes } from "@/utilities";


// in minutes
const SOURCE_TO_INTERVAL_MAP = {
  // ЕПГУ
  1: 60,
  // mos.ru
  2: 30,
};


export default {
  name: "CreateTimeslotForm",


  components: {
    VField,
    VButton,
  },


  props: {
    sources: {
      type: Array,
      default() {
        return [];
      }
    },
  },


  data() {
    return {
      newSlot: {
        startTime: {
          hour: "10",
          minutes: "00"
        },
        endTime: {
          hour: "20",
          minutes: "00"
        },
        interval: 60,
        overlaps: 1,
        capacity: 1,
        source: null
      }
    };
  },


  computed: {
    currentTimeInterval() {
      return `${this.newSlot.startTime.hour}:${this.newSlot.startTime.minutes} - ${this.newSlot.endTime.hour}:${this.newSlot.endTime.minutes}`;
    },
  },


  watch: {
    /**
     * Set the first source from the list as a default
     */
    sources(v) {
      if (this.newSlot.source === null && v.length > 0) {
        this.newSlot.source = v[0].id;
      }
    },

    "newSlot.source"(v) {
      if (SOURCE_TO_INTERVAL_MAP[v]) {
        this.newSlot.interval = SOURCE_TO_INTERVAL_MAP[v];
      }
    },

    "newSlot.startTime.hour"(v) {
      if (v.length >= 2) {
        if (validateHour(v)) {
          this.$refs.newStartTime_minutes.setFocus();
        } else {
          this.$nextTick(() => (this.newSlot.startTime.hour = v.slice(0, -1)));
        }
      }
    },

    "newSlot.startTime.minutes"(v) {
      if (v.length >= 2) {
        if (validateMinutes(v)) {
          this.$refs.newEndTime_hour.setFocus();
        } else {
          this.$nextTick(
            () => (this.newSlot.startTime.minutes = v.slice(0, -1))
          );
        }
      }
    },

    "newSlot.endTime.hour"(v) {
      if (v.length >= 2) {
        if (validateHour(v)) {
          this.$refs.newEndTime_minutes.setFocus();
        } else {
          this.$nextTick(() => (this.newSlot.endTime.hour = v.slice(0, -1)));
        }
      }
    },

    "newSlot.endTime.minutes"(v) {
      if (v.length >= 2) {
        if (validateMinutes(v)) {
          this.$refs.newEndTime_minutes.setBlur();
        } else {
          this.$nextTick(() => (this.newSlot.endTime.minutes = v.slice(0, -1)));
        }
      }
    },

    "newSlot.capacity"(v) {
      this.checkOverlapsAndCapacity();
    },

    "newSlot.overlaps"(v) {
      this.checkOverlapsAndCapacity();
    },
  },


  methods: {
    submitNewSlot() {
      this.$emit("submit-new-slot", this.newSlot);
    },

    /**
     * Capacity can't be less than overlaps or overlaps won't make sense
     *
     * TODO: just a stub to make a little bit of sense
     */
    checkOverlapsAndCapacity() {
      if (this.newSlot.capacity < this.newSlot.overlaps) {
        this.newSlot.capacity = this.newSlot.overlaps;
      }
    },
  },
};
</script>

<style lang="scss">
.add-time {
  display: flex;
  align-items: center;
  margin: 30px 0;
  .field {
    margin: 0;
  }
  .time-dots {
    margin: 0 10px;
  }
  .input {
    width: calc(2em + 20px);
    text-align: center;
  }
  .link {
    margin-left: 15px;
    white-space: nowrap;
  }
}
</style>
